import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { primaryCalculatorId } from '../../core/reducers/financialCalculators';
import { useFetchCurrentVehicleFinancialCalculatorPayment } from '../../core/apiHooks/useFetchPayment';
const calculateTop = () => {
    const summaryBarEl = document.getElementById('bap-summary-bar');
    const summaryBarHeight = (summaryBarEl === null || summaryBarEl === void 0 ? void 0 : summaryBarEl.getBoundingClientRect().height) || 0;
    return summaryBarHeight;
};
const useSummaryBarTop = () => {
    const [summaryBarTop, setSummaryBarTop] = useState(0);
    const { isFetching: isPaymentDataFetching, isLoading: isPaymentDataLoading, isSuccess: isPaymentDataSuccess, } = useFetchCurrentVehicleFinancialCalculatorPayment(primaryCalculatorId);
    const calculateAndSetTop = () => setSummaryBarTop(calculateTop());
    useEffect(() => {
        const debouncedCalculateTop = debounce(calculateAndSetTop, 300);
        calculateAndSetTop();
        window.addEventListener('resize', debouncedCalculateTop);
        window.addEventListener('touchmove', debouncedCalculateTop);
        window.addEventListener('scroll', debouncedCalculateTop);
        return () => {
            window.removeEventListener('resize', debouncedCalculateTop);
            window.removeEventListener('touchmove', debouncedCalculateTop);
            window.removeEventListener('scroll', debouncedCalculateTop);
        };
    }, []);
    useEffect(() => {
        if (isPaymentDataFetching || isPaymentDataLoading || isPaymentDataSuccess) {
            calculateAndSetTop();
        }
    }, [isPaymentDataFetching, isPaymentDataLoading, isPaymentDataSuccess]);
    return summaryBarTop;
};
export default useSummaryBarTop;
